import React from 'react';
import CourseList from './components/CourseList';
import Calendar from './components/Calendar';

const Capacitacion: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-100 p-4">
      <div className="container mx-auto">
        <div className="flex gap-4">
          <div className="w-3/4 flex flex-col gap-2">
            <CourseList />
            <CourseList />
          </div>
          <div className="w-1/4">
            <Calendar />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Capacitacion;
